import React, { useEffect, useRef, useState } from 'react'
import Style from '../VerifierInternalDashboard/index.module.css'
import templateStyles from './Templates.module.css'
import styles from '../Document.module.css'

import { Link, useLocation, useNavigate } from "react-router-dom";
import API from '../../../ApiConfig'
import { GET_VERIFIER_FORMS, DELETE_VERIFIER_FORM, ACTIVATE_VERIFIER_FORM, DEACTIVATE_VERIFIER_FORM, DEACTIVATE_MASTER_FORMS } from '../../../Utils/constant'
import cogoToast from 'cogo-toast-react-17-fix'
import dayjs from "dayjs"
import { createPortal } from 'react-dom';
const FormsTable = ({ data, title, setSortBy,sortBy, setFormSearch, searchText }) => {
    // const [data, setData] = useState({ "0": [{ "linked_documents": [], }], "1": [{ "linked_documents": [], }] })
    const [activeIndex, setActiveIndex] = useState(null)
    const [FormModal, setFormModal] = useState(false)
    const [loading, setLoading] = useState(false)
    const location = useLocation();
    const path = location.pathname
    const [openMenu, setOpenMenu] = useState(null);
    const [QRModal, setQrLink] = useState(false)
    const dropdownRef = useRef(null)
    const updatePopup = (bool) => {
        setFormModal(bool);
    };
    const navigate = useNavigate();

    function deleteForm(form_id) {
        setLoading(true)
        API.delete(DELETE_VERIFIER_FORM + form_id)
            .then(res => {
                setLoading(false)
                cogoToast.success(res.data.data)
                getVerifierForms()

            })
            .catch(err => cogoToast.error('Something went wrong!'))
    }

    function deactivateForm(form_uuid, form_id, toggleState) {
        const state = toggleState ? 'deactivate' : 'activate'
        API.put(`${DEACTIVATE_MASTER_FORMS}${form_uuid}/${form_id}/${state}`)
            .then(res => {
                cogoToast.success(res.data.data)
                getVerifierForms()
            })
            .catch(err => cogoToast.error('Something went wrong!'))
    }
    const SortList=(sort)=>{
        let direction = "asc";

        if (sortBy.key === sort && sortBy.direction === "asc") {
            direction = "desc";
        }
        const newSortBy = { key:sort, direction }
        setSortBy(newSortBy)
    }
    const handleAction = (id, event) => {
        const buttonRect = event.currentTarget.getBoundingClientRect()
        setOpenMenu((prev)=>prev?.id === id ? null : { id, top: buttonRect.top, left: buttonRect.left })

    }

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setOpenMenu(null); // Close the dropdown
        }
    }

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [])
    const [searchData, setsearchData] = useState([])

    const DropdownMenu = ({ isOpen,position, children }) => {
        if (!isOpen || !position) return null;
    
        return createPortal(
            <div className={styles.ActionMenu} style={{top: position.top + window.scrollY + 30,left: position.left}} ref={dropdownRef}>
                {children}
            </div>,
            document.body // Render the dropdown at the root of the DOM
        );
    }
    useEffect(() => { setsearchData(data) }, [data])
    // search
    const [search, setSearch] = useState(null)

    const handleSearch = (e) => {
        setFormSearch(e)
    }


    return (<>
        <section className={`${templateStyles.searchHeader} table-header6`}>
            <div>
                {title}
            </div>
            <div className="inputField2">
                <div className="input1">
                    <div className="content1">
                        <img className="searchOutlineIcon1" alt="" src="/searchoutline.svg" />
                        <input value={searchText} onChange={e => handleSearch(e.target.value)} className="inputText1" placeholder="Search" />
                    </div>
                </div>
            </div>
        </section>
        <div className={Style.wrapper} style={{ paddingBottom: "10rem" }}>
            <table style={{ overflow: "visible" }}>
                <thead>
                    <tr className='credentials-header bg-lgray'>
                        <th className="credentials-th">Form Name</th>
                        <th className="credentials-th">Fields Name</th>
                        <th className="credentials-th" style={{display:"flex", gap:"6px"}}>
                            <div>Created At</div>
                            <div className={styles.dropdown} style={{cursor:"pointer"}} onClick={(e)=>SortList("created_at")}>
                                <img className={styles.chevronSortIcon} alt="" src="/chevronsort.svg"/>
                            </div>
                        </th>
                        <th className="credentials-th">Last Updated On</th>
                        <th className="credentials-th">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {Object.keys(data).map((key, index) => {
                        // console.log(data[key]);

                        return (
                            <tr key={index} className='credentials-tr' style={{ animationDelay: `${index * 0.1}s`, position:"relative", overflow:"visible" }}>
                                <td className="credentials-td">
                                    <div className='credentials-table-text1'>{data[key].form_name}</div>
                                </td>
                                <td className="credentials-td" style={{display: "flex", flexDirection: "column", flexWrap: "wrap" }}>
                                    {data[key]?.required_doc_fields && data[key]?.required_doc_fields.length > 0 ? data[key].required_doc_fields.map((item, i) => (
                                        <div key={i} className={Style.tdTitle} style={{whiteSpace:"nowrap"}}>
                                            {item.doc_field_name}
                                            {i < data[key].required_doc_fields.length - 1 ? <span>, </span> : null}
                                            <div className={Style.tdList}>
                                                {item.linked_documents.map((doc, j) => (
                                                    <div key={j}>{doc}</div>
                                                ))}
                                            </div>
                                        </div>
                                    ))
                                        : data[key]?.required_documents && data[key]?.required_documents.length > 0 ? data[key].required_documents.map((item, i) => (
                                            <div key={i} className={Style.tdTitle}>
                                                {item.master_document_name}
                                                {i < data[key].required_documents.length - 1 ? <span>, </span> : null}
                                            </div>
                                        )) : null
                                    }
                                </td>
                                <td className="credentials-td">
                                    {dayjs(data[key].created_at).format('DD MMM YYYY')}
                                </td>
                                <td className="credentials-td">
                                    {dayjs(data[key].updated_at).format('DD MMM YYYY')}
                                </td>
                                <td className="credentials-td" style={{ position: "relative" }}>
                                    <div className={Style.center}>
                                        <button className={`btn ${styles.editPencil}`} style={{ margin: "0px 10px" }} onClick={() => navigate(`/company/2/2/verification-fields/${data[key].form_uuid}`, { state: data[key] })}>
                                            <img src='/eyeoutline.svg' className={styles.editicon} />
                                        </button>
                                        {data[key]?.is_active ?
                                            <button className={`btn ${styles.editPencil}`} style={{ margin: "0px 10px" }} onClick={() => navigate(`/company/2/2/verification-fields/${data[key].form_uuid}`, { state: data[key] })}>
                                                <img src='/EditPencil.svg' className={styles.editicon} />
                                            </button> :
                                            <button className={`btn ${styles.disabled}`} style={{ cursor: 'not-allowed' }} onClick={() => cogoToast.warn("Please activate form")}>
                                                <img src='/EditPencil.svg' className={styles.editicon} />
                                            </button>
                                        }
                                        <div style={{ position: "relative" }}>
                                            <span className={openMenu?.id === index ? styles.moreSelected : styles.more} style={{cursor: "pointer", zIndex: 10}} onClick={(e) => handleAction(index,e)}>
                                                <img src='/morevert.svg' alt='morevert.svg' />
                                            </span>
                                            
                                                <div className={styles.ActionMenu}>
                                                    <DropdownMenu isOpen={openMenu?.id===index} position={openMenu}>
                                                    <button
                                                        onClick={() => { navigate(`/company/2/2/verification-fields/${data[key].form_uuid}`, { state: data[key] }); setOpenMenu(null) }}
                                                        className={styles.menuItems}>
                                                        <span className={styles.menu}>
                                                            <img src='/eyeoutline.svg' className={styles.editicon} /> View Details
                                                        </span>
                                                    </button>
                                                    <hr style={{ margin: "0px" }} />
                                                    {data[key]?.is_active ?
                                                        <button onClick={() => { navigate(`/company/2/2/verification-fields/${data[key].form_uuid}`, { state: data[key] }); setOpenMenu(null) }} className={styles.menuItems}>
                                                            <span className={styles.menu}>
                                                                <img src='/EditPencil.svg' className={styles.editicon} />
                                                                Edit
                                                            </span>
                                                        </button> :
                                                        <button
                                                            onClick={() => cogoToast.warn("Please activate form")}
                                                            className={styles.menuItems}
                                                            style={{ cursor: "not-allowed", color: "gray" }}
                                                        >
                                                            <span className={styles.menu}>
                                                                <img src='/EditPencil.svg' className={styles.editicon} />
                                                                Edit
                                                            </span>
                                                        </button>
                                                    }
                                                    <hr style={{ margin: "0px" }} />
                                                    </DropdownMenu>
                                                    {/* <button
                                                        onClick={() => { deactivateForm(data[key].form_uuid, data[key].form_id, data[key]?.is_active); setOpenMenu(null) }}
                                                        className={styles.menuItems}
                                                    >
                                                        <span className={styles.menu}>
                                                            <img src='/deactivate.svg' className={styles.editicon} />
                                                            {data[key]?.is_active ? "Deactivate" : "Activate"}
                                                        </span>
                                                    </button> */}
                                                </div>
                                            
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
        {/* <Modal title={QRModal.form_name + " QR"} isOpen={QRModal} onClose={() => setQrLink(false)} blockOutsideClick={true}>
            <GenerateQR form_uuid={QRModal.form_uuid} verifier_id={id} />
        </Modal> */}
    </>

    )

    // <Modal title="Select how you want to create form" isOpen={FormModal} onClose={updatePopup} blockOutsideClick={true} children={<ModalForm />}>
    // </Modal>

}

export default FormsTable